
export default defineNuxtPlugin(() => {
  const route = useRoute();
  let lasthashed = '';

  watch([
    () => route.fullPath,
    () => route.query,
  ], () => {
    const idempotency = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    const hashed = JSON.stringify([route.query, route.fullPath]);

    if (hashed == lasthashed) {
      console.log('[rt] route already sent, skipping');
      return;
    }

    lasthashed = hashed;

    if(!document){
      return api.post('information/route', {
        fullPath: route.fullPath,
        query: route.query,
        idempotency,
      })
    }


    ws.send('information.route', {
      fullPath: route.fullPath,
      query: route.query,
      idempotency,
    }).catch(() => {
      api.post('information/route', {
        fullPath: route.fullPath,
        query: route.query,
        idempotency,
      })
    })
  })
});
